var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 101,
    viewBox: "0 0 73 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 0.5C16.5303 0.5 0.283791 16.7465 0.283791 36.716C0.283791 61.4988 32.6937 97.8814 34.0736 99.4182C35.3697 100.862 37.6326 100.859 38.9264 99.4182C40.3063 97.8814 72.7162 61.4988 72.7162 36.716C72.7158 16.7465 56.4695 0.5 36.5 0.5ZM36.5 54.9373C26.4527 54.9373 18.2789 46.7633 18.2789 36.716C18.2789 26.6687 26.4529 18.4949 36.5 18.4949C46.5471 18.4949 54.7209 26.6689 54.7209 36.7162C54.7209 46.7635 46.5471 54.9373 36.5 54.9373Z",
    fill: "#46973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f9187626998c53bfd283e20aea09552a.svg";
export { ForwardRef as ReactComponent };